export default "__VITE_ASSET__DpzMTauG__"